var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"rong-quote-imagetext-link",attrs:{"href":_vm.message.content.content.url,"target":"_blank"}},[_vm._v("["+_vm._s(_vm.locale.components.quoteMessage.link)+"] "+_vm._s(_vm.message.content.content.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }